// extracted by mini-css-extract-plugin
export default {"banner":"SliderImage_banner__+uYln","bannerDesktop":"SliderImage_bannerDesktop__nrdLT","bannerMobile":"SliderImage_bannerMobile__-uQn4"};